import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { IconButton, IconButtonProps, styled } from '@mui/material'

interface ExpandMoreIconWrapperProps extends IconButtonProps {
  expand: boolean
}

interface ExpandMoreProps {
  expand: boolean
}

const ExpandMoreIconWrapper = styled((props: ExpandMoreIconWrapperProps) => {
  const { expand, ...other } = props
  return <IconButton {...other} />
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}))

const ExpandMore = ({ expand }: ExpandMoreProps) => {
  return (
    <ExpandMoreIconWrapper
      expand={expand}
      aria-expanded={expand}
      aria-label="show more"
    >
      <ExpandMoreIcon />
    </ExpandMoreIconWrapper>
  )
}

export default ExpandMore
